import Brightness5RoundedIcon from '@mui/icons-material/Brightness5Rounded';
import BusinessRoundedIcon from '@mui/icons-material/BusinessRounded';
import HomeWorkRoundedIcon from '@mui/icons-material/HomeWorkRounded';
import MenuBookRoundedIcon from '@mui/icons-material/MenuBookRounded';
import TerrainRoundedIcon from '@mui/icons-material/TerrainRounded';
import WbIncandescentRoundedIcon from '@mui/icons-material/WbIncandescentRounded';
import {
  alpha,
  Avatar,
  Box,
  Card,
  Grid,
  Typography,
  useTheme,
} from '@mui/material';

/**
 * Short pieces of info about the S3G training
 */
const InfoBits = () => {
  const theme = useTheme();
  return (
    <Box paddingY={6}>
      <Grid container spacing={4}>
        {[
          {
            title: 'Confidence in Safety',
            infoBit:
              'Discover proven techniques to manage threats effectively and create a safer, more secure workplace environment.',
            icon: <BusinessRoundedIcon fontSize="large" />,
          },
          {
            title: 'Training for Every Situation',
            infoBit:
              'Our expert-led training prepares you to stay safe—at work, at home, in your community, and wherever life takes you.',
            icon: (
              <WbIncandescentRoundedIcon
                fontSize="large"
                sx={{ transform: 'rotate(180deg)' }}
              />
            ),
          },
          {
            title: 'Survival Strategies',
            infoBit:
              'Learn actionable tactics and strategies to increase your chances of surviving real-world crisis situations.',
            icon: <Brightness5RoundedIcon fontSize="large" />,
          },
          {
            title: 'Threat Prevention',
            infoBit:
              'Enhance your observational and situational awareness skills to identify early warning signs of potentially violent behavior',
            icon: <TerrainRoundedIcon sx={{ fontSize: '2.2em' }} />,
          },
          {
            title: 'For All Organizations',
            infoBit:
              'Our principles and tactics apply to businesses, churches, hospitals, schools, and organizations of all kinds.',
            icon: <HomeWorkRoundedIcon fontSize="large" />,
          },
          {
            title: 'Real-World Insights',
            infoBit:
              'Based on real-life experiences and years of research, our training reveals behavioral patterns and warning signs to prevent violence.',
            icon: <MenuBookRoundedIcon fontSize="large" />,
          },
        ].map((item, i) => (
          <Grid item xs={12} sm={6} md={4} key={i} data-aos={'fade-up'}>
            <Card
              elevation={4}
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                padding: 5,
                height: '100%',
              }}
            >
              <Box
                component={Avatar}
                width={72}
                height={72}
                marginBottom={2}
                bgcolor={alpha(theme.palette.primary.main, 0.1)}
                borderRadius="3px"
              >
                <Box color={theme.palette.primary.main}>{item.icon}</Box>
              </Box>
              <Typography
                variant={'h6'}
                gutterBottom
                fontWeight={700}
                textAlign="center"
              >
                {item.title}
              </Typography>
              <Typography textAlign="center">{item.infoBit}</Typography>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default InfoBits;
